{
  "data_entry_is_paused": "Het invoeren van stemmen is gepauzeerd",
  "definitive": {
    "title": "Alle stembureaus zijn twee keer ingevoerd",
    "message": {
      "GSB": "De resultaten van alle stembureaus in jouw gemeente zijn correct ingevoerd. Je kunt de uitkomst nu definitief maken en het proces-verbaal opmaken. Doe dit alleen als er vandaag niks meer herteld hoeft te worden.",
      "CSB": "De resultaten van het gemeentelijk stembureau zijn correct ingevoerd. Je kunt de uitkomst nu definitief maken en het proces-verbaal opmaken. Doe dit alleen als er vandaag niks meer herteld hoeft te worden."
    },
    "finish_button": "Invoerfase afronden"
  },
  "label": "Status",
  "main_title": "Statusoverzicht invoer",
  "no_investigations_with_corrected_results": "Er zijn nog geen onderzoeken met gecorrigeerde uitkomst voor deze zitting.",
  "no_polling_stations": "Er zijn nog geen stembureaus toegevoegd voor deze verkiezing.",
  "pause": "Pauzeren",
  "pause_are_you_sure": "Weet je zeker dat je wilt pauzeren? Invoerders kunnen niet verder werken.",
  "pause_session": "Zitting pauzeren",
  "paused_status_information": "Het is nu niet mogelijk om nieuwe stembureaus in te laten voeren. Invoerders kunnen wel inloggen. Hervat de invoer om weer verder te gaan.",
  "polling_stations_per_status": "Stembureaus per status",
  "resume": "Hervatten",
  "start": "Starten",
  "success": {
    "choose_another_typist": "Kies hiervoor een andere invoerder dan {typist}.",
    "data_entries_discarded": "Omdat beide invoeren zijn verwijderd, moet stembureau {number} twee keer opnieuw ingevoerd worden.",
    "data_entry_corrected": "De invoer die niet klopt moet worden hersteld door {typist}.",
    "data_entry_discarded": "Invoer stembureau {nr} verwijderd",
    "data_entry_kept": "Omdat er nog maar één invoer over is, moet er een nieuwe tweede invoer gedaan worden.",
    "data_entry_resumed": "Stembureau {nr} teruggegeven aan {typist}",
    "differences_resolved": "Verschil opgelost voor stembureau {number}",
    "polling_station_can_be_filled_again": "Het stembureau kan opnieuw ingevoerd worden",
    "typist_can_continue_data_entry": "De invoerder kan verder met invoeren"
  },
  "title": "Statusoverzicht"
}
